import React from 'react';
import { Link } from 'react-router-dom';
import { MainContainer, TitleContainer, LoadingContainer, Paragraph, Card, CardInline, ColumnContainer, Column } from '@beacharound/beacharound-ui';
import LazyLoad from 'react-lazyload';
import { useInView } from 'react-hook-inview';

import {
    getAddressString,
    getImageCrop,
} from "@beacharound/beacharound-ui-helpers";
import { getPlaceholderImage } from '../../helpers/images/getPlaceholderImage';
import PrerenderMeta from '../Prerender/PrerenderMeta';

export default function ActivitiesList({
    data,
    isLoading,
    isLoadingMore,
    showText,
    city,
    searchText,
    inlineCards,
    fetchMore,
    hasMore,
    columns,
    listName,
    marginBottom
}) {
    const searchString = searchText ? `corrispondenti a <strong>"${searchText}"</strong>` : "";
    const cityString = city ? `a <strong>"${city}"</strong>` : "";

    const [ref] = useInView({
        onEnter: () => {
            if (fetchMore && typeof fetchMore === "function") {
                return fetchMore();
            }
        },
    });

    return (
        <MainContainer lowMargin={marginBottom}>
            <LoadingContainer isLoading={isLoading}>
                <PrerenderMeta isLoading={isLoading} />
                {showText && (
                    <TitleContainer>
                        <Paragraph
                            text={`Abbiamo trovato <strong>${data?.length || 0} risultati</strong> per te ${searchString} ${cityString}`}
                        />
                    </TitleContainer>
                )}

                <ColumnContainer noMargin>
                    {data?.map((item, index) => {

                        let chipLeft, chipRight;

                        if (item.bookable === true) {
                            chipLeft = [
                                {text: `Prenota ora`}
                            ]
                        }

                        if (item.bookable === true && item.hasMap) {
                            chipLeft = [
                                ...(chipLeft || []),
                                {text: "Scegli il tuo posto!", color: "blue"}
                            ]
                        }

                        if (item.bookable === true && !!item.promotion) {
                            chipRight = [
                                {text: `In promo! -${item.promotion.value}%`, color: "red"}
                            ];
                        }

                        if (item.bookable === true && !!item.hasMenu) {
                            chipRight = [
                                ...(chipRight || []),
                                {text: `Menù disponibile`, color: "green"}
                            ];
                        }

                        if (item.bookable === true && !!item.hasEvents) {
                            chipRight = [
                                ...(chipRight || []),
                                {text: `Eventi in spiaggia`, color: "green"}
                            ];
                        }

                        if (inlineCards) {

                            return (
                                <Column
                                    column={columns || 2}
                                    key={item._id || index}
                                >
                                    <LazyLoad height={120}>
                                        <CardInline
                                            notify={item.notify}
                                            noBorder
                                            title={item.name || item.title}
                                            subtitle={item.description}
                                            subtitleColor={item.descriptionColor}
                                            description={item.info || getAddressString(item.address)}
                                            image={item.cover?.length > 0 ? getImageCrop(item.cover, "m") : getPlaceholderImage(item.type, item)}
                                            rating={item.reviews?.average}
                                            ratingsLength={item.reviews?.count}
                                            component={Link}
                                            to={listName ? `${item.to}?listName=${listName}&listIndex=${index + 1}` : item.to}
                                        />
                                    </LazyLoad>
                                </Column>
                            );
                        }

                        return (
                            <Column column={2} key={item._id || index}>
                                <LazyLoad height={200}>
                                    <Card
                                        noBorder
                                        notify={item.notify}
                                        title={item.name}
                                        subtitle={item.description}
                                        description={item.info || getAddressString(item.address)}
                                        image={item.cover?.length > 0 ? item.cover : getPlaceholderImage(item.type, item)}
                                        imgChipLeft={chipLeft}
                                        imgChipRight={chipRight}
                                        rating={item.reviews?.average}
                                        ratingsLength={item.reviews?.count}
                                        component={Link}
                                        to={listName ? `${item.to }?list_name=${listName}&list_index=${index + 1}` : item.to}
                                    />
                                </LazyLoad>
                            </Column>
                        );
                    })}
                </ColumnContainer>
                {!isLoading && !isLoadingMore && hasMore && (
                    <span ref={ref}></span>
                )}
            </LoadingContainer>
        </MainContainer>
    );
}